import { mapState } from 'vuex'

export default {
    data() {
        return {
            summary: {
                CELL: {},
                FIX: {},
                NET: {},
                TV: {},
                ENERGY: {}
            }
        }
    },

    watch: {
        currentMap: {
            handler(){
                this.calcSummary()
            },
            deep: true
        }
    },

    mounted() {
        this.calcSummary()
    },

    methods: {
        calcSummary() {
            this.products.forEach(product => {
                if(!this.summary.hasOwnProperty(product.reference)) return
                for(let i = 1; i <= product.slots_max; i++) {
                    let slotKey = product.reference+i
                    if(!this.currentMap.hasOwnProperty(slotKey)) return
                    this.$set(this.summary[product.reference], slotKey, this.currentMap[slotKey] !== 0)
                }
            })
        }
    },

    computed: {
        ...mapState('products', {
            products: state => state.products,
            currentMap: state => state.selection.currentMap
        }),

        totalCellProducts() {
            return Object.values(this.summary['CELL']).filter(slot => slot === true).length
        },

        totalFixProducts() {
            return Object.values(this.summary['FIX']).filter(slot => slot === true).length
        },

        totalNetProducts() {
            return Object.values(this.summary['NET']).filter(slot => slot === true).length
        },

        totalTvProducts() {
            return Object.values(this.summary['TV']).filter(slot => slot === true).length
        },

        totalPerseoProducts() {
            return Object.values(this.summary['PERSEO']).filter(slot => slot === true).length
        },

        totalEnergyProducts() {
            return Object.values(this.summary['ENERGY']).filter(slot => slot === true).length
        }
    }
}
